// extracted by mini-css-extract-plugin
export default {"box":"QATile_box__n7W07","dibba":"QATile_dibba__Pkzeb"};